import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getGeneralInventory = async ({ commit }, query) => {
  commit('setGeneralInventoryIsLoading', true);
  await connection.post(`/generalinventory`, query)
    .then(res => {
      commit('setGeneralInventory', res.data.data);
      commit('setGeneralInventoryIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setGeneralInventoryIsLoading', false);
    });
}

export const loadGeneralInventory = async ({ commit }, query = null) => {
  commit('setGeneralInventoryIsLoading', true);
  let page = 1;
  let search = '';
  let perPage = 25;
  if(query !== null){
    page = query?.page || 1;
    search = query?.search || '';
    perPage = query?.perPage || 25;
  }
  let url = `/generalinventory`;
  
  if (search === '') {
    url = `${url}?page=${page}&perPage=${perPage}&clientId=${query.clientId}&subsidiaryId=${query.subsidiaryId}`;
  } else {
    url = `${url}?search=${encodeURIComponent(search)}&page=${page}&perPage=${perPage}&clientId=${query.clientId}&subsidiaryId=${query.subsidiaryId}`;
  }

  await connection.get(url)
    .then(res => {
      commit('setGeneralInventory', res.data);
      const pagination = {
          totalItems: res.data.totalItems,
          currentPage: res.data.currentPage,
          totalPages: res.data.totalPages,
          perPage: res.data.perPage 
      }
      res.data.pagination = pagination;
      commit('setGeneralInventoryPaginated', res.data);
      commit('setGeneralInventoryIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setGeneralInventoryIsLoading', false);
    });
}